export function returnFuncIfServer(func) {
    // We don't allow debouncing in SSR environments
    // eslint-disable-next-line @faire-web/no-restricted-globals
    return "object" === "undefined" ? func : undefined;
}
